<!--<template>
  <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px"
           class="demo-ruleForm login-container">
    <h3 class="title">系统登录</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" style="width:45%;" @click.native.prevent="handleSubmit2" :loading="logining">登录
      </el-button>
      <el-button type="primary" style="width:45%;" @click.native.prevent="handleSubmit" :loading="logining">注册
      </el-button>
    </el-form-item>

  </el-form>
</template>-->
<template>
  <div class="homepage" :style="styleChange">
    <div class="login-box">
      <!--<div class="login-left">
        <img class="login-left-img" src="../assets/login-img-left.png" alt="">
      </div>-->
      <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" class="login-form-box">
        <div class="login-form-title">快出租</div>
        <el-form-item prop="account">
          <div class="input-box">
            <input class="login-form-input" v-model="ruleForm2.account" type="text" placeholder="请输入用户名">
            <img class="input-icon" src="../assets/icon-user.png" alt="">
          </div>
        </el-form-item>
        <el-form-item prop="checkPass">
          <div class="input-box">
            <input class="login-form-input" v-model="ruleForm2.checkPass" type="password" placeholder="请输入密码">
            <img class="input-icon" src="../assets/icon-password.png" alt="">
          </div>
        </el-form-item>
        <div class="btn-box">
          <div class="remember-box">
            <div>
              <el-checkbox v-model="checked" checked class="remember"></el-checkbox>
              记住密码
            </div>
          </div>
          <el-button class="login-btn" type="primary" @click.native.prevent="handleSubmit2"
                     :loading="logining">立即登录
          </el-button>
        </div>
      </el-form>
    </div>

    <el-dialog
            title="修改密码"
            :visible.sync="dialogVisible"
            width="40%"
            :before-close="cancelForm"
    >
      <el-form
              size="medium"
              status-icon
              ref="form"
              :rules="formRules"
              :model="form"
              label-width="100px"
      >
        <el-form-item label="原密码" prop="oldPassWord" style="margin-bottom: 34px;">
          <el-input type="password" v-model="form.oldPassWord" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassWord" style="margin-bottom: 34px;">
          <el-input type="password" v-model="form.newPassWord" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassWord"  style="margin-bottom: 34px;">
          <el-input type="password" v-model="form.confirmPassWord" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click.native="dialogVisible = false">>取 消</el-button>
        <el-button
                size="medium"
                :loading="passWordLoading"
                type="primary"
                @click="updatePassWord"
        >确认修改
        </el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
/* eslint-disable */
import {doPost, base, getDownLoadUrl} from '../api/api'
import {resetRouter, formatMenuToRouter} from '../routes'
import {validatorSocialCreditCode, validatorPhone} from "../api/util";
import SIdentify from './../components/SIdentify';

export default {
  components: {SIdentify},
  data() {
    const qualifiValidate = (rule, value, callback) => {
      if (value.indexOf("1") == -1) {
        callback(new Error("请勾选资格证！"));
      } else {
        callback();
      }
    };
    let _this = this;
    return {
      zoom: 16,
      center: [119.647265, 29.079195],
      searchOption: {
        // 限制搜索城市的范围
        citylimit: false,
      },
      defaultValue: "",
      content: "",
      inputValue: "",
      searchResult: {
        address: "",
        latitude: "",
        longitude: "",
        name: "",
        type: "",
        country: "",
        province: "",
        city: "",
        area: "",
        township: "",
        street: "",
        neighborhood: "",
        locationName: "",
      },
      events: {
        click(e) {
          _this.center = [e.lnglat.lng, e.lnglat.lat];
          _this.form.lon = e.lnglat.lng;
          _this.form.lat = e.lnglat.lat;
          _this.getAddress(_this.center);
          _this.defaultValue = "";
        },
      },
      styleChange: {
        width: '',
        fontSize: '14'
      },
      cateProps: {
        label: 'deptName',
        children: '',
        value: 'id'
      },
      disabled: false,
      visible: true,
      logining: false,
      user: {},
      passWordLoading: false,
      form: {
        oldPassWord: '',
        newPassWord: '',
        confirmPassWord: ''
      },
      doorway: false,
      business: false,
      idupper: false,
      idlower: false,
      qualifiCer: false,
      formVisible: false,
      dialogVisible: false,
      tipinput: '',
      title: '资质认证',
      loading: false,
      options: [], // 地区下拉
      types: [],
      area: [],
      formLoading: false,
      uploadFiles: [],
      checkList: [0, 0],
      uploadUrl: base + '/sysUploadFile/uploadFile', // 上传附件
      formRules: {
        oldPassWord: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { pattern: /^.{6,}$/, message: '最少6位字符!', trigger: 'change' }
          // { min: 6, message: '最少6位字符', trigger: 'blur' }
        ],
        newPassWord: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^.{6,}$/, message: '最少6位字符!', trigger: 'change' }
        ],
        confirmPassWord: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { pattern: /^.{6,}$/, message: '最少6位字符!', trigger: 'change' }
        ]
      },
      ruleForm2: {
        account: '',
        checkPass: '',
      },
      rules2: {
        account: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        checkPass: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        verificationCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      },
      checked: true,
      qualifiVisible: false,
      unifiedCode: '',
      identifyCode: '',
      identifyCodes: '1234567890abcdefjhijklinopqrsduvwxyz',
      counter: 0,
      interval: null,
    }
  },
  mounted() {
    var toLogin = this.$route.query.toLogin
    if (toLogin === '1') {
      this.$message({
        message: '登录超期，请重新登录！',
        type: 'error'
      })
    }
    this.resize();
    // this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    updatePassWord () {
      if (this.form.newPassWord === this.form.oldPassWord) {
        this.$message({
          message: '新密码与原密码输入一致,不可提交',
          type: 'error'
        })
        return
      }
      if (this.form.confirmPassWord !== this.form.newPassWord) {
        this.$message({
          message: '确认密码与新密码不匹配',
          type: 'error'
        })
        return
      }
      let para = {
        id: this.user.id,
        userName: this.user.userName,
        password: this.form.oldPassWord,
        newPass1: this.form.confirmPassWord
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认修改密码吗?', '提示', {})
                  .then(() => {
                    this.passWordLoading = true
                    doPost('/sysUser/editPass', para).then((res) => {
                      this.passWordLoading = false
                      if (res.result) {
                        this.dialogVisible = false
                        this.$message({
                          message: '修改成功',
                          type: 'success'
                        })
                        var _this = this
                        this.$confirm('是否重新登录?', '提示', {
                          // type: 'warning'
                        })
                                .then(() => {
                                  doPost('/sysUser/loginOut', {}).then((data) => {
                                    sessionStorage.removeItem('user')
                                    sessionStorage.removeItem('menuList')
                                    sessionStorage.removeItem('tabsItem')
                                    _this.$router.push('/login')
                                  })
                                })
                                .catch(() => {
                                })
                      } else {
                        this.$message({
                          message: '原密码错误',
                          type: 'error'
                        })
                      }
                    })
                  })
                  .catch(() => {
                  })
        }
      })
    },

    // // 刷新验证码
    // refreshCode() {
    //   this.identifyCode = ''
    //   this.makeCode(this.identifyCodes, 4);
    // },
    // makeCode(o, l) {
    //   for (let i = 0; i < l; i++) {
    //     this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
    //   }
    // },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    onSearchResult(pois) {
      //搜索
      let latSum = 0;
      let lngSum = 0;
      let that = this;
      if (pois && pois.length > 0) {
        //如果长度为1则无需转化
        let poi = pois[0];
        let lng = poi["lng"];
        let lat = poi["lat"];
        that.center = [lng, lat];
        that.zoom = 18;
        that.content = poi.name;
        that.searchResult.address = poi.address;
        that.searchResult.latitude = poi.lat;
        that.searchResult.longitude = poi.lng;
        that.form.lon = lng;
        that.form.lat = lat;
        that.getAddress(that.center);
      } else {
        that.searchResult = [];
      }
      console.log(that.center)
    },
    // 获取详细地址
    getAddress(center) {
      let _this = this;
      let geocoder = new AMap.Geocoder({});
      geocoder.getAddress(center, function (status, result) {
        if (status === "complete" && result.info === "OK") {
          // let obj = result.regeocode.addressComponent;
          // let locationName =
          //     obj.province +
          //     obj.city +
          //     obj.district +
          //     obj.township +
          //     obj.street +
          //     obj.streetNumber;
          // _this.form.address = locationName;
          var address = result.regeocode.formattedAddress
          _this.form.address = address
        }
      });
    },
    handleReset2() {
      this.$refs.ruleForm2.resetFields()
    },
    loginSuccessMe(user) {
      debugger
      var para = {
        userId: user.id
      }
      doPost('/sysMenu/getSysMenuTree', para).then(data => {
        // 处理菜单
        var userRoutes = formatMenuToRouter(data.result)
        // 重置路由
        resetRouter()
        // 初始化菜单
        this.$router.addRoutes(userRoutes)
        var rightList = data.result
        var firstPath = rightList[0].sonList[0].path
        sessionStorage.setItem('user', JSON.stringify(user))
        sessionStorage.setItem('firstPath', firstPath)
        this.$router.push({path: firstPath})
      })
    },
    handleSubmit2(ev) {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true
          var loginParams = {userName: this.ruleForm2.account, password: this.ruleForm2.checkPass}
          doPost('/sysUser/login', loginParams).then(data => {
            this.logining = false
            if (data.code === 200) {
              sessionStorage.setItem('user', JSON.stringify(data.result))

              // 取消密码强度验证
              this.loginSuccessMe(data.result)

              return
              this.loginSuccessMe(data.result)

            } else {
              this.$message({
                message: data.result,
                type: 'error'
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resize() {
      const that = this;
      var setFont = function () {
        var width = window.innerWidth;
        if (width < 1024) width = 1024
        if (width > 1920) width = 1920
        var fontSize = width / 80 + 'px';
        that.styleChange.width = width + 'px'
        that.styleChange.fontSize = fontSize;
      }
      setFont();
      window.onresize = function () {
        setFont();
      }
    },
    showMap() {
      this.dialogVisible = true
    },
    sureMapAddress() {
      this.dialogVisible = false
    },
    // 注册
    handleSubmit() {
      this.getTypesData()
      this.formVisible = true
    },
    // 认证查询
    handleQuery() {
      this.qualifiVisible = true
    },
    callBack: function () {
      this.qualifiVisible = false;
    },
    // 点击取消(处理规则校验)
    cancelForm() {
      this.formVisible = false
      this.$refs['form'].resetFields()
    },
    // 验证图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 10

      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是JPG格式或PNG格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    // 数据字典类型
    getTypesData() {
      var str = []
      doPost('/sysDict/getAllList', {dictType: 'qualifi_type'}).then(res => {
        for (var i in res.result) {
          str.push(res.result[i])
        }
        this.types = str;
      })
      doPost('/dept/getSecondDeptTree', {}).then(res => {
        this.options = res.result
      })
    },
    handleChange(value) { // 所在地区选择
      if (value.length > 0) {
        this.form.county = value[0]
      } else {
        this.form.county = '';
      }
    },
    // 照片保存
    handleSuccess(res, file, fileList, strUrl) {
      if (strUrl === 'doorway') {

        this.form.doorway = getDownLoadUrl(file.response.result);
        this.form.doorwayName = file.name
        this.doorway = file.response.result
        console.log(this.doorway)
      } else if (strUrl === 'business') {
        this.form.business = getDownLoadUrl(file.response.result);
        this.form.businessName = file.name
        this.business = file.response.result
      } else if (strUrl === 'idupper') {
        this.form.idupper = getDownLoadUrl(file.response.result);
        this.form.idupperName = file.name
        this.idupper = file.response.result
      } else if (strUrl === 'idlower') {
        this.form.idlower = getDownLoadUrl(file.response.result);
        this.form.idlowerName = file.name
        this.idlower = file.response.result
      } else if (strUrl === 'qualifiCer') {
        this.form.qualifiCer = getDownLoadUrl(file.response.result);
        this.form.qualifiCerName = file.name
        this.qualifiCer = file.response.result
      }
    },

    formSubmit: function () {
      this.uploadFiles.push({
        fileUrl: this.doorway,
        fileName: this.form.doorwayName,
        modelType: 'doorway'
      })
      this.uploadFiles.push({
        fileUrl: this.business,
        fileName: this.form.businessName,
        modelType: 'business'
      })
      this.uploadFiles.push({
        fileUrl: this.idupper,
        fileName: this.form.idupperName,
        modelType: 'idupper'
      })
      this.uploadFiles.push({
        fileUrl: this.idlower,
        fileName: this.form.idlowerName,
        modelType: 'idlower'
      })
      this.uploadFiles.push({
        fileUrl: this.qualifiCer,
        fileName: this.qualifiCerName,
        modelType: 'qualifiCer'
      })
      this.form.uploadFileStr = this.uploadFiles.length === 0 ? '' : JSON.stringify(this.uploadFiles)
      this.form.status = '1'
      console.log(this.checkList);
      this.form.qualifi = this.checkList.join(',')
      console.log(this.form)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗', '提示', {
            confirmButtonText: '继续提交',
            cancelButtonText: '取消'
          }).then(() => {
            this.formLoading = true
            let para = Object.assign({}, this.form)
            doPost('/hospital/saveOrUpdate', para).then((res) => {
              this.formLoading = false
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.cancelForm()
            })
          })
        }
      })
    }
  },


}

</script>

<!--<style lang="scss" scoped>-->
<style lang="scss" scoped>
.code-top {
  display: flex;
  align-items: center;
  color: #333;
  font-size: 18px;
  margin-bottom: 27px;

  .code-icon {
    margin-left: 10px;
  }

  .code-position {
    width: 24%;
    margin-right: 26px;
    flex-shrink: 0;
    text-indent: 1em;
  }

  .code-fresh {
    font-size: 12px;
    font-weight: 400;
    color: #1993DA;
    line-height: 12px;
    align-self: end;
    text-decoration: underline;
    margin-right: 5%;
    flex-shrink: 0;
    cursor: pointer;
  }
}

.code-bottom {
  display: flex;
  font-size: 18px;
  color: #333;

  .code-number {
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    margin-right: 22%;
    flex-shrink: 0;
    align-self: end;
    text-indent: 3.5em;
  }


}

::v-deep {
  .el-form-item__error {
    text-indent: 6em;
  }

  .code-input {
    display: inline-block;
    width: 15%;
    height: 43px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .code-input .el-input__inner {
    background: #E9F7FF;
    border: 1px solid #1993DA;
  }


}

.input-box {
  position: relative;

  .yzmButton {
    position: absolute;
    right: 15px;
    top: 0;
  }
}


/*
.login-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
}*/
::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 200px;
  height: 100px;
}

::v-deep  .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

::v-deep  .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

::v-deep .avatar {
  width: 200px;
  height: 100px;
  display: block;
}

.homepage {
  line-height: 1.15;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  background: url("../assets/login-bg.png");
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-title-img {
  margin-top: 15vh;
  width: auto;
  height: 40px;
}

.login-title-box {
  color: #409EFF;
  text-align: center;
  letter-spacing: 2px;
}

.login-title {
  margin-top: 5vh;
  font-size: 1em;
  margin-bottom: 0.2em;
}

.login-title-english {
  font-size: 0.9em;
}

.login-box {
  box-sizing: border-box;
  /*width: 24em;*/
  /*height: 24em;*/
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background: url("../assets/login-bg2.png");
  background-size: 100% 100%;
  /*margin: 0 0 0 60%;*/
  display: flex;
  align-items: center;
  width: 80%;
  height: 80%;
}

.img-box {
  /*height: 20em;*/
  /*border-right: 2px solid #ccc;*/
  /*padding-left: 3em;*/
}

.img-box img {
  display: block;
  width: 100%;
  height: auto;
  /*margin-top: 3em;*/
}

.login-form-box {
  margin: 0 4em;
  width: 24em;
}

.login-form-title {
  font-size: 1.6em;
  /*width: 5em;*/
  text-align: center;
  margin: 1em auto;
  padding: 0.2em;
  /*color: #3077D1;*/
  font-weight: 600;
  color: #1993DA;
}

.input-box {
  position: relative;
  padding: 0 1em;
  margin-top: 1.2em;
}

.yanzheng-box {
  position: absolute;
  right: 1em;
  bottom: 0.2em;
}

.login-form-input {
  width: 100%;
  border: none;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  box-sizing: border-box;
  /*color: #3077D1;*/
  display: inline-block;
  font-size: 0.8em;
  height: 3.4em;
  line-height: 3.4em;
  outline: 0;
  padding: 0 3em;
}

/*::-webkit-input-placeholder {
  color: #9DBEEA;
}*/
.input-icon {
  /*width: 1.16em;*/
  width: 1.33em;
  height: 1.33em;
  position: absolute;
  top: 0.5em;
  left: 1.4em;
}

.btn-box {
  padding: 0 1em;
  overflow: hidden;
}

.remember-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2em 1em;
  font-size: 0.7em;
  color: #50A4DE;
}

.remember {
  margin-right: 3px;
  font-size: 1em;
}

.login-btn {
  width: 86%;
  color: #fff;
  margin: 3em auto 1em;
  border-radius: 40px;
  height: 2.8em;
  text-align: center;
  background-color: #1993DA;
  cursor: pointer;
  font-size: 0.8em;
  box-shadow: 0 8px 8px rgba(25, 147, 218, 0.2);
  display: block;
}

.login-left-img {
  display: block;
  width: 26em;
  height: auto;
}

.el-form-item {
  margin-bottom: 0;
}

.login-box ::v-deep  .el-form-item__content {
  font-size: inherit;
  line-height: inherit;
}

</style>
